import { css } from '@lastbrand/web-ui-styled-system/css'

export const wrapperBaseClass = css({
  width: 'full',
  borderTop: '1px solid',
  borderColor: 'lightgray',
  paddingTop: 'space-40',
  marginTop: 'space-40',
  lgDown: {
    // Shared by the non-PL buy box (`ProductPurchase.tsx`) as well as the PL widgets, so it stays at
    // the non-PL value. The PL surface adds its extra below-1200px gap on its own side, via the
    // ACCORDION widget's `mt` — see `accordion-widget-ds.tsx`.
    marginBottom: 'space-20',
  },
})

export const contentBaseClass = css({
  textStyle: 'body-14',
  color: 'black',
  '& a': {
    borderBottom: '1px solid',
    borderColor: 'black',
  },
})

export const iconsWrapperClass = css({
  my: 'space-24',
})
